import {
    Box, Center, Heading, Stack,
    Text
} from '@chakra-ui/react';
import InputField from '../InputField';
import { FormStep } from '../MultiStepForm';

export default function ShortBio(props: { shortBio: string, onSubmit: any, handleInputChange: any, validationSchema: any }) {
    const { shortBio, onSubmit, handleInputChange, validationSchema } = props;
    return (
        <FormStep
            stepName="shortBio"
            onSubmit={onSubmit}
            validationSchema={validationSchema}
        >
            <Center>
                <Box w="530px">
                    <Stack align="center">
                        <Heading
                            lineHeight="36px"
                            fontSize="32px"
                            letterSpacing="-0.02em"
                            fontWeight="800"
                            width="616px"
                            textAlign="center"
                        >
                            Tell us about yourself in one sentence
                        </Heading>
                        <Text
                            fontWeight={400}
                            lineHeight="16px"
                            fontSize="11px"
                            align="center"
                            width="616px"
                        >
                            Example: Sophomore at UVA majoring in Economics currently looking for a
                            Summer 2023 internship in Finance.
                        </Text>
                        <InputField
                            name="shortBio"
                            align="center"
                            width="530px"
                            type="textarea"
                            height="106px"
                            placeholder="Placeholder"
                            handleInputChange={handleInputChange}
                            fieldValue={shortBio}
                        />
                    </Stack>
                    <Text
                        fontSize="11px"
                        fontWeight="400"
                        width="530"
                        align="right"
                        color={250 - shortBio.length < 0 ? 'red' : 'black'}
                    >
                        {250 - shortBio.length} Characters Remaining
                    </Text>
                </Box>
            </Center>
        </FormStep>
    );
}
